export default __webpack_public_path__ + "static/char-s-04-chs-abaf8f634609da6c1177be0522de2c8c.webp";